import View from '@shared/components/layout-default/layout-default-router-view';

export const hlr = [
  {
    path: 'hlr',
    component: View,
    children: [
      {
        path: '',
        name: 'hlr.index',
        redirect: {
          name: 'hlr.requests.index'
        }
      },
      {
        path: 'requests',
        name: 'hlr.requests.index',
        component: () => import(/* webpackChunkName: 'hlr' */ '@hlr/pages/hlr-list-page'),
        meta: {
          title: {
            code: 'hlr.breadcrumb.requests.index'
          },
          permissions: ['module_hlr_is_allowed']
        }
      }
    ]
  }
];
